/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './..\\convo\\defs.defs.js'

const $nsid = 'chat.bsky.group.listMutualGroups'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 1 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  subject: /*#__PURE__*/ l.string({ format: 'did' }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  convos: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ConvoDefs.ConvoView>(
      (() => ConvoDefs.convoView) as any,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Returns a page of group conversations that both the requester and the specified actor are members of. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
